"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shared = require("@widget-editor/shared");

var _actions = require("@widget-editor/shared/lib/modules/configuration/actions");

var _actions2 = require("@widget-editor/shared/lib/modules/theme/actions");

var _selectors = require("@widget-editor/shared/lib/modules/configuration/selectors");

var _component = _interopRequireDefault(require("./component"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _shared.redux.connectState(function (state) {
  return {
    options: (0, _selectors.selectChartOptions)(state),
    chartType: state.configuration.chartType,
    theme: state.theme
  };
}, {
  patchConfiguration: _actions.patchConfiguration,
  setTheme: _actions2.setTheme
})(_component["default"]);

exports["default"] = _default;